import { useEffect, useState } from 'react';
import styles from '../AddCategoryModal.module.css';
import { API_URL } from '../../../config/api';

const AddCategoryModal = ({ onClose, onSave }) => {
  const [name, setName] = useState('');
  const [parent, setParent] = useState('');
  const [parentOptions, setParentOptions] = useState([]);
  const token = localStorage.getItem('token'); // ✅ Берём токен

  // ✅ Загружаем категории при открытии модалки
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        console.log('📡 Загружаем категории...');
        const res = await fetch(`${API_URL}/api/product_categories`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // ✅ Добавили токен
          },
        });

        console.log('GET status:', res.status);

        const data = await res.json();
        console.log('GET categories response:', data);

        if (Array.isArray(data.data)) {
          setParentOptions(data.data);
          localStorage.setItem('categories', JSON.stringify(data.data));
        } else {
          console.warn('⚠️ Ожидался массив категорий, но пришло:', data);
        }
      } catch (error) {
        console.error('Ошибка при получении категорий:', error);

        // 🔹 Подгружаем из localStorage при ошибке
        const saved = localStorage.getItem('categories');
        if (saved) setParentOptions(JSON.parse(saved));
      }
    };

    if (token) fetchCategories();
    else console.error('❌ Нет токена! Авторизация не выполнена.');
  }, [token]);

  // ✅ Добавление новой категории
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      console.warn('⚠️ Поле "Наименование" пустое — отправка отменена.');
      return;
    }

    const payload = {
      title: name,
      parent_id: parent ? Number(parent) : 0,
    };

    console.log('📤 Отправляем POST запрос:', payload);

    try {
      const res = await fetch(`${API_URL}/api/product_categories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // ✅ Токен для POST
        },
        body: JSON.stringify(payload),
      });

      console.log('POST status:', res.status);

      const data = await res.json();
      console.log('POST response:', data);

      if (!res.ok) {
        console.error('❌ Ошибка при создании категории:', data);
        alert(`Ошибка (${res.status}): ${data.errors?.message || 'Неизвестная ошибка'}`);
        return;
      }

      const newCategory = {
        id: data.id,
        name: data.title,
        parent_id: data.parent_id,
      };

      // 🔹 Обновляем localStorage
      const saved = localStorage.getItem('categories');
      const updated = saved ? [...JSON.parse(saved), newCategory] : [newCategory];
      localStorage.setItem('categories', JSON.stringify(updated));

      // 🔹 Обновляем родительский компонент
      onSave(newCategory);

      // Сбрасываем поля
      setName('');
      setParent('');

    } catch (err) {
      console.error('💥 Ошибка при выполнении POST-запроса:', err);
      alert(`Ошибка при добавлении категории: ${err.message}`);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Добавление категории товара</h3>
          <button onClick={onClose} className={styles.close}>×</button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <label>Родительская категория</label>
          <select
            value={parent}
            onChange={(e) => setParent(e.target.value)}
            className={styles.select}
          >
            <option value="">Поиск категории</option>
            {parentOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.title}
              </option>
            ))}
          </select>

          <label>
            Наименование <span className={styles.required}>*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={styles.input}
            required
          />

          <button type="submit" className={styles.saveBtn}>Сохранить</button>
        </form>
      </div>
    </div>
  );
};

export default AddCategoryModal;
